module.exports = __webpack_public_path__ + "static/img/ikonaMikrofon-OFF.44e30663.png";